import React from "react";
import { formatReportHtml } from "../../../utils/formatReportHtml";

interface Props {
  open: boolean;
  onClose: () => void;
  loading: boolean;
  report: any;
}

const RapidTrustDrawer: React.FC<Props> = ({
  open,
  onClose,
  loading,
  report,
}) => {
  return (
    <>
      {/* Overlay */}
      <div
        onClick={onClose}
        className={`fixed inset-0 bg-black/40 backdrop-blur-sm z-40 transition ${
          open ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
      />

      {/* Drawer */}
      <div
        className={`
          fixed
          right-0
          top-[64px]
          h-[calc(100vh-64px)]
          w-full
          sm:w-[520px]
          lg:w-[780px]
          bg-white
          shadow-[0_30px_60px_rgba(0,0,0,0.15)]
          z-50
          transform transition-transform duration-500
          ${open ? "translate-x-0" : "translate-x-full"}
        `}
      >
        {/* Header */}
        <div className="flex justify-between items-center px-4 sm:px-6 lg:px-10 py-4 sm:py-5 lg:py-7 border-b border-[#eef0f6]">

          <h2 className="text-lg sm:text-xl lg:text-[22px] font-semibold text-[#26295e] truncate pr-4">
            {report?.title}
          </h2>

          <button
            onClick={onClose}
            className="text-[#7b82a8] hover:text-[#26295e] text-lg sm:text-xl"
          >
            ✕
          </button>

        </div>

        {/* Content */}
        <div className="h-full overflow-y-auto px-4 sm:px-6 lg:px-12 py-6 sm:py-8 lg:py-10 pb-20 sm:pb-24 lg:pb-28">

          {loading && (
            <p className="text-[#7b82a8] text-sm sm:text-[16px]">
              Loading report...
            </p>
          )}

          {!loading && report && (
            <div
              className="
                text-sm sm:text-base lg:text-[18px]
                leading-7 sm:leading-8 lg:leading-9
                text-[#4b507d]
                space-y-4
              "
              dangerouslySetInnerHTML={{
                __html: formatReportHtml(report.details),
              }}
            />
          )}

        </div>
      </div>
    </>
  );
};

export default RapidTrustDrawer;